export const GetSubDomain = () => {
  let location = window.location.href;
  let subDomainsCollection = ["fctkd", "rstkd", "prtkd"];
  let subDomain = subDomainsCollection.find((subDomainItem) => location.includes(subDomainItem));
  if (subDomain === undefined) subDomain = "";
  // //console.log("GetSubDomain -> subDomain=", subDomain);
  return subDomain;
};
